import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-130ab63b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-12 member-h" }, "ご利用履歴")
], -1))
const _hoisted_2 = { class: "row justify-content-center mt-4" }
const _hoisted_3 = { class: "col-12 member-name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, "日時", -1))
const _hoisted_5 = { class: "col-7" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, "コース", -1))
const _hoisted_7 = { class: "col-7" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, "ご利用料金", -1))
const _hoisted_9 = { class: "col-7" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, "ポイント利用", -1))
const _hoisted_11 = { class: "col-7" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, "お支払い金額", -1))
const _hoisted_13 = { class: "col-7" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, "お支払い方法", -1))
const _hoisted_15 = { class: "col-7" }

import { Member, WorkHistory, PaymentMethod } from '@/models';
import { DataStore, SortDirection } from 'aws-amplify';
import {ref, reactive, inject, onMounted, toRefs, watch} from 'vue'
import { useRoute, useRouter } from 'vue-router';

import dayjs from 'dayjs'
import 'dayjs/locale/ja'

interface Props {
  member: Member;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null
  },
  emits: ['stopLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
}



const { member } = toRefs(props);



const route = useRoute();
const router = useRouter();

const histories = ref();

watch(member, async() => {
  console.log("update");
  try {
    histories.value = await DataStore.query(WorkHistory,
      (w) => w.workHistoryMemberId('eq', member.value.id),
      {
        sort: w => w.createdAt(SortDirection.DESCENDING)
      });

    console.log(histories.value);
  }
  catch(e){
    console.log(e);
    router.push('/login');
  }

  emit('stopLoading');
});

const getPaymentMethod = (history: WorkHistory) => {
  if (history.paymentMethod == PaymentMethod.CASH) {
    return '現金';
  }
  else if (history.paymentMethod == PaymentMethod.PAYPAY) {
    return 'PayPay';
  }
  else if (history.paymentMethod == PaymentMethod.POINT) {
    return 'ポイント';
  }
}

const getCode = () => {
  return ('000000' + member.value.codeNum).slice(-6);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString(_unref(member).name) + " 様", 1),
        _createElementVNode("div", null, "会員番号:" + _toDisplayString(getCode()), 1)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(histories.value, (history, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row history mt-3",
        key: idx
      }, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(dayjs)(history.createdAt).format('YYYY/MM/DD HH:mm')), 1),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString(history.Course.name) + " " + _toDisplayString(history.Course.minute) + "分", 1),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, "¥ " + _toDisplayString(history.Course.price?.toLocaleString()), 1),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, "-" + _toDisplayString(history.Course.price?.toLocaleString()) + "pt (1pt = 1円)", 1),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, "¥ " + _toDisplayString(history.Course.price?.toLocaleString()), 1),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(getPaymentMethod(history)), 1)
      ]))
    }), 128))
  ], 64))
}
}

})